import React, { useLayoutEffect, useState } from "react";
import { useUser } from "../utils/UserProvider";
import { useNavigate } from "react-router-dom";

const withProtectedRoute = (
  WrappedComponent
) => {
  const ProtectedRoute = (props) => {
    const navigate = useNavigate()

    const { user, loading } = useUser()
    const [isRedirecting, setIsRedirecting] = useState(false);

    useLayoutEffect(() => {
      if (!loading && !user) {
        setIsRedirecting(true);
        navigate("/login");
      } else {
        setIsRedirecting(false);
      }
    }, [user, loading, navigate]);

    if (isRedirecting) return null;

    return user ? <WrappedComponent {...props} /> : null;
  };

  return ProtectedRoute;
};

export default withProtectedRoute;
